import { createContext, RefObject, useContext } from 'react';

const HybridCarouselViewportContext = createContext<RefObject<HTMLDivElement> | null>(null);

export const HybridCarouselViewportProvider = HybridCarouselViewportContext.Provider;

export function useCarouselViewport(): HTMLDivElement | null {
  const ref = useContext(HybridCarouselViewportContext);
  return ref?.current ?? null;
}
